<template>
  <div>
    <PlatformRenderer>
      <!-- START : Mobile Edit Button -->
      <template v-slot:onMobile>
        <button
          class="btn btn-link link-primary underline-link-from-center"
          @click="customizeMobile()"
          data-testid="mobileButton"
          ref="editItemBtnRef"
        >
          <font-awesome-icon icon="pencil" size="sm" /> {{ $t('editItem') }}
        </button>
      </template>
      <!-- END : Mobile Edit Button -->
      <!-- START : Desktop Edit Button -->
      <template v-slot:onDesktop>
        <button
          class="btn btn-link link-primary underline-link-from-center"
          @click="customizeDesktop()"
          data-testid="desktopButton"
          ref="editItemBtnRef"
        >
          <font-awesome-icon icon="pencil" size="sm" /> {{ $t('editItem') }}
        </button>
      </template>
      <!-- END : Desktop Edit Button -->
    </PlatformRenderer>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import ModalService from '@/modules/modals/services/modal.service';
import WCItemModifierRoot from '@/modules/itemModifiers/components/WCItemModifierRoot/WCItemModifierRoot.vue';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import WCRandomWeightModal from '@/modules/cart/components/WCRandomWeightModal/WCRandomWeightModal.vue';

export default {
  name: 'WCEditItemButton',
  props: {
    lineItem: {},
    isRandomWeightedItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { PlatformRenderer },
  methods: {
    ...mapActions({
      modifyItem: 'items/modifyItem',
    }),
    async customizeDesktop() {
      if (this.isRandomWeightedItem) {
        await this.customizeWeightDesktop();
      } else {
        await this.customizeMadeToOrderDesktop(this.lineItem.variation);
      }
    },
    async customizeMadeToOrderDesktop(variation) {
      try {
        await ModalService.open(WCItemModifierRoot, {
          lineItem: this.lineItem,
          item: this.lineItem.item,
          editingItem: true,
          variation,
          cartInstructions: this.lineItem.instructions,
        });
      } catch (error) {
        console.log(error);
      } finally {
        if (this.$refs.editItemBtnRef) this.$refs.editItemBtnRef.focus();
      }
    },
    async customizeWeightDesktop() {
      try {
        await ModalService.open(WCRandomWeightModal, {
          item: this.lineItem.item,
          orderType: this.orderType,
        });
      } catch (error) {
        console.log(error);
      } finally {
        if (this.$refs.customizeBtnRef) this.$refs.customizeBtnRef.focus();
      }
    },
    async customizeMobile() {
      if (this.isRandomWeightedItem) {
        await this.goToWeightCustomizePage();
      } else {
        await this.goToMadeToOrderCustomizePage(this.lineItem.variation);
      }
    },
    goToMadeToOrderCustomizePage(variation) {
      this.$router.push({
        name: 'Customize Your Item',
        params: { id: this.lineItem.item.id, name: this.lineItem.item.name },
        query: { variation, editingItem: true },
      });
    },
    goToWeightCustomizePage() {
      this.$router.push({
        name: 'Customize Your Item Weight',
        params: { id: this.lineItem.item.id, name: this.lineItem.item.name },
      });
    },
  },
};
</script>
